import React from "react";
import RiskQuestionnaire from "./Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire";

const RiskQuestionnaireHolder = () => {
  return (
    <div className="page-content">
      <div className="head-section">
        <h1 className="text-uppercase"></h1>
      </div>

      <div className="buildPortfolio__main">
        <RiskQuestionnaire />
      </div>
    </div>
  );
};

export default RiskQuestionnaireHolder;



// WEBPACK FOOTER //
// ./src/components/pages/RiskQuestionnaireHolder.jsx